import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Wrapper from "../../../components/wrapper";
import PropTypes from "prop-types";
import SearchInput from "../search/searchInput";
import "./styles.css";
import { NavLink } from "react-router-dom";
import RestaurantInfo from "./info/index";
import RestaurantLogs from "./logs/index";
import RestaurantSummary from "./summary/index";

export class RestaurantDetails extends React.Component {
  render() {
    const infoPath = {
      pathname: "/restaurants/" + this.props.restaurantId,
      search: this.props.locationSearch,
    };
    const logsPath = {
      pathname: "/restaurants/" + this.props.restaurantId + "/logs",
      search: this.props.locationSearch,
    };
    const summaryPath = {
      pathname: "/restaurants/" + this.props.restaurantId + "/summary",
      search: this.props.locationSearch,
    };

    let tab = null;
    switch (this.props.selectedTab) {
      case "logs":
        tab = <RestaurantLogs id={this.props.restaurantId} />;
        break;

      case "summary":
        tab = <RestaurantSummary id={this.props.restaurantId} />;
        break;

      default:
        tab = <RestaurantInfo restaurantId={this.props.restaurantId}></RestaurantInfo>;
        break;
    }

    return (
      <div className="restaurant-details">
        <Wrapper title="Restaurants">
          <SearchInput key={`${this.props.searchType}/${this.props.searchText}`} searchText={this.props.searchText} searchType={this.props.searchType} />
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <NavLink id="navRestaurantInfo" exact className="nav-link" activeClassName={"active"} to={infoPath}>
                Info
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink id="navRestaurantLogs" className="nav-link" activeClassName={"active"} to={logsPath}>
                Logs
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink id="navRestaurantSummary" className="nav-link" activeClassName={"active"} to={summaryPath}>
                Summary
              </NavLink>
            </li>
          </ul>
          <div>{tab}</div>
        </Wrapper>
      </div>
    );
  }
}

RestaurantDetails.propTypes = {
  searchText: PropTypes.string,
  searchType: PropTypes.string,
  restaurantId: PropTypes.number,
  selectedTab: PropTypes.string,
  locationSearch: PropTypes.string,
};

const mapStateToProps = (state, props) => {
  return {
    searchText: state.restaurantSearch.searchText,
    searchType: state.restaurantSearch.searchType,
    restaurantId: props.restaurantId,
    locationSearch: state.router.location.search || '',
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RestaurantDetails);



// WEBPACK FOOTER //
// ./src/containers/restaurants/details/index.js